angular.module('assets')
    .component('catalogOrSerialNumber', {
        bindings: {
            catalog: '<?',
            serial: '<?'
        },
        template: `
            <span ng-if="$ctrl.text">{{$ctrl.text}}</span>
        `,
        controller: function () {
            this.$onInit = () => {
                this.text = [this.catalog, this.serial].filter(c => c).join(' / ');
            };
        },
    })
